export default __webpack_public_path__ + "static/media/plate-method.2261124c.png";